import axios, { AxiosResponse } from "axios";
import qs from "qs";

const http = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;

export function createPost<U>(path: string): () => Promise<U>;
export function createPost<T, U>(path: string): (data: T) => Promise<U>;
export function createPost<T, U>(path: string) {
  return (data: T) =>
    http.post<U, AxiosResponse<U>, T>(path, data).then((res) => res.data);
}

export function createGet<T>(path: string): () => Promise<T>;
export function createGet<T, U extends object>(
  path: string
): (querys?: U) => Promise<T>;
export function createGet<T, U>(path: string) {
  return (querys?: U) => {
    const query = qs.stringify(querys || {});

    return http
      .get<T, AxiosResponse<T>, unknown>(query ? path + "?" + query : path)
      .then((res) => res.data);
  };
}
